import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {SetAuditTrail} from './../Reports/AuditTrailReportEmployeeSetup';
import {useTable, useSortBy} from 'react-table';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import {token, domain} from '../Security';
import { format } from 'date-fns';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DoneIcon from '@mui/icons-material/Done';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from "@mui/icons-material/Close";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import ChecklistIcon from '@mui/icons-material/Checklist';

function MassApproval({user, isHideSideMenu}) {
    var headerForOvertimeList = [
        "Employee Id",
        "Employee",
        "Date",
        "Original Hours",
        "Hours",
        "Overtime Classification",
        "Reason",
        "Is Approved?",
        "Details",
        "",
    ]
    var accessorForOvertimeList = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "date",
        "originalHours",
        "overtimeInHours",
        "overtimeClassification",
        "reason",
        "hasBeenPostedAsApproved",
        "details",
        "manage"
    ]

    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    const [showDeleteAll, setShowDeleteAll] = useState(false);
    const [showPostStagingConfirmationForm, setShowPostStagingConfirmationForm] = useState(false);
    
    const [filterDataIndexForOvertimeList, setFilterDataIndexForOvertimeList] = useState(0);
    const [overtimeRequestDataForOvertimeList, setOvertimeRequestDataForOvertimeList] = useState([]);
    const [filterDataForOvertimeList, setFilterDataForOvertimeList] = useState([]);

    const [filterPayrollPeriodId, setFilterPayrollPeriodId] = useState("");
    const [filterLocationId, setFilterLocationId] = useState("");

    //Approve
    const [showApproveForm, setShowApproveForm] = useState(false);
    const [selectedDTR, setSelectedDTR] = useState([]);
    const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [isUnselectAll, setIsUnselectAll] = useState(false);

    const openApproveForm = () => {
        if(selectedDTR.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select at least 1 data");

            return;
        }

        setShowApproveForm(true);
    }
    const closeApproveForm = () => {
        setShowApproveForm(false);
    }

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const [showDownloadLogs, setShowDownloadLogs] = useState(false);
    const openDownloadLogs = () => {
        setShowDownloadLogs(true);
    }
    const closeDownloadLogs = () => {
        setShowDownloadLogs(false);
    }
    
    const [selectedToAdd, setSelectedToAdd] = useState([]);
    const handleFilterForOvertimeList = (value) => {
        setCurrentPage(1);

        const lowercaseValue = value.toLowerCase();

        const res = filterDataForOvertimeList.filter((f) =>
            f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue) ||
            f.employeePersonalInformationEmployeeId.toString().startsWith(lowercaseValue)
        );

        setOvertimeRequestDataForOvertimeList(res);
    };


    const fetchDataForEmployee = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForEmployeesPerTimeKeeper = useCallback(async () => {
        const apiUrl =  domain + `/api/Employee/employee-schedules/timekeeper/${user.employeePersonalInformationId}`;

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);
    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/OvertimeRequestFromBiometrics/payrollperiod/${filterPayrollPeriodId}/location/${filterLocationId ? filterLocationId : 0}`;

        try{
            setLoading(true);
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            // console.log('Final bulkData:', JSON.stringify(filteredData, null, 2));

            let finalData = response.data;

            if(filterDataIndexForOvertimeList === 1){
                finalData = response.data?.filter(i => !i.hasBeenPostedAsApproved)
            } else if(filterDataIndexForOvertimeList === 2){
                finalData = response.data?.filter(i => i.hasBeenPostedAsApproved)
            }

            // Update states with filtered data
            setOvertimeRequestDataForOvertimeList(finalData);
            setFilterDataForOvertimeList(finalData);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
            setIsUnselectAll(true);
        }
    }, [filterPayrollPeriodId, filterLocationId, filterDataIndexForOvertimeList]);

    /* useEffect(()=>{
        fetchData();
    }, [fetchData]) */

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('Template');

        const employeesPerTimeKeeper = await fetchDataForEmployeesPerTimeKeeper();

        const header = [
            'EmployeeId',
            'EmployeeName',
            'Date',
            'Hours',
            'Type',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'employeeName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'hours', width: 30 },
            { key: 'type', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        employeesPerTimeKeeper.forEach(info => {
            const information = {
                    employeeId: info.employeeId,
                    employeeName: info.employeeFullName,
                    date: '<mm/dd/yyyy>',
                    hours: '<2.00>',
                    type: 'Regular',
            };

            worksheet1.addRow(information);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Mass_Approval_Template.xlsx');
    }, [fetchDataForEmployeesPerTimeKeeper]);
    const uploadEmployeeData = async (file) => {
        setLoadingRequest(true);
        const dataEmployee = await fetchDataForEmployee();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }

        function sanitizeValueInteger(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 0;
            }
            return value;
        }
    
        const validateData = (data) => {
            const missingFields = [];
    
            data.forEach((item, index) => {
                const missing = [];

                let foundEmployee = null;

                foundEmployee = dataEmployee.find(data => (data.id).toString() === (item.employeePersonalInformationId).toString());

                if (!Number.isInteger(item.hours)) {
                    // missing.push('Daily Salary');
                    missingFields.push(`Row ${index + 1}: Invalid value - Hours`);
                }
                if (!foundEmployee) {
                    // missing.push('Section');
                    missingFields.push(`Row ${index + 1}: Missing Employee Id`);
                }
                if (!item.date) {
                    // missing.push('Section');
                    missingFields.push(`Row ${index + 1}: Missing Date`);
                }
                if (!item.hours) {
                    // missing.push('Section');
                    missingFields.push(`Row ${index + 1}: Missing Hours`);
                }
                if (!item.overtimeType) {
                    // missing.push('Section');
                    missingFields.push(`Row ${index + 1}: Missing Type`);
                }

                if (missing.length > 0) {
                    missingFields.push(`Row ${index + 1}: Missing fields - ${missing.join(', ')}`);
                }
            });
    
            if (missingFields.length > 0) {
                return {
                    isValid: false,
                    message: `Invalid data in the file. Please check the mandatory fields.\n${missingFields.join('\n')}`
                };
            }
    
            return { isValid: true };
        }

        function excelDateToJSDate(excelDate) {
            const date = new Date((excelDate - 25569) * 86400 * 1000);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    
        function convertToDateTimeLocal(dateStr) {
            const datetimeLocal = excelDateToJSDate(dateStr);
            const [day, month, year] = datetimeLocal.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`;
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];
    
            informations.forEach(info => {
                let foundEmployee = null;

                foundEmployee = dataEmployee.find(data => data.employeeId.toLowerCase() === sanitizeValue(info.EmployeeId).toString().toLowerCase());

                // i will use the locations, employments etc. here below
                bulkData.push({
                    employeePersonalInformationId: foundEmployee ?
                                sanitizeValue(foundEmployee.id)
                                :
                                0,
                    date: info.Date ? 
                                sanitizeValue(info.Date) ? convertToDateTimeLocal(info.Date) : ""
                                :
                                "",
                    hours: info.Hours ? 
                                sanitizeValueInteger(info.Hours)
                                :
                                0,
                    overtimeType: info.Type ? 
                                sanitizeValue(info.Type)
                                :
                                "",
                    dateRequested: new Date(),
                    status: "Sent",
                    requestTypeId: 3, // 3 is Overtime Request
                    approverId: null,
                    reason: "",
                    reasonForRejection: "",
                    hasOvertimeAllowance: false,
                    isAboveTwoHoursOvertime: false,
                    content: ""
                });
            });

            // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            // Validate the bulk data
            const validation = validateData(bulkData);
            if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
        
                const errorMessages = validation.message.split('\n').filter(line => line);
        
                if (errorMessages.length > 10) {
                    // Export to Excel
                    const workbook = XLSX.utils.book_new();
                    const worksheetData = [["Row", "Error Message"]];
        
                    errorMessages.forEach((message, index) => {
                        worksheetData.push([`Row ${index + 1}`, message]);
                    });
        
                    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Errors");
        
                    XLSX.writeFile(workbook, "errorFile.xlsx");
                } else {
                    // Display the messages directly
                    setRequestMessage(errorMessages.map((line, index) => (
                        <div key={index}>{line}</div>
                    )));
                }
            }

            const upload = async (data) => {
                const apiUrl = `${domain}/api/OvertimeRequestStaging/bulk`;
            
                try {
                    const response = await axios.post(apiUrl, data, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    
                    await fetchData();
                    setLoadingRequest(false);
                    setRequestMessage('Upload successful');
                    setShowRequestMessage(true);
                    setIsSuccess(true);
                    console.log('Upload successful:', response.data);
                } catch (error) {
                    setLoadingRequest(false);
                    setShowRequestMessage(true);
                    setIsSuccess(false);
                    console.error('Error:', error);
                    const errorMessage = error.response?.data?.message || 'An error occurred';
                    setRequestMessage(errorMessage);
                }
            }

            upload(bulkData);
            
            /* const handleBulkUpload = async () => {
                try {
                    await Promise.all(bulkData.map(data => upload(data)));
                    await fetchData();
                    setLoadingRequest(false);
                    setRequestMessage('Upload successful');
                    setShowRequestMessage(true);
                    setIsSuccess(true);
                } catch (error) {
                    setLoadingRequest(false);
                    setShowRequestMessage(true);
                    setIsSuccess(false);
                    console.error('Error:', error);
                    const errorMessage = error.response?.data?.message || 'An error occurred';
                    setRequestMessage(errorMessage);
                }
            }
            
            handleBulkUpload(); */
        };
    
        reader.readAsArrayBuffer(file);
    };
    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }
    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }

    const handleGenerate = async () => {
        if(!filterPayrollPeriodId){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please fill up payroll period!");
            return;
        }

        await fetchData();
    }

    const fetchDataApproverHierarchy = useCallback(async () => {
        const apiUrl =  domain + "/api/ApproverHierarchy";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataEmployees = useCallback(async (id) => {
        const apiUrl = domain +"/api/Employee";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const getApproverContact = async (myApprover, employeesInfo) =>{
        const formatPhoneNumber = (number) => {
            // Remove all dashes
            const cleanedNumber = number.replace(/-/g, '');
        
            // Check if the number starts with '0' and remove it
            const formattedNumber = cleanedNumber.startsWith('0') 
                ? '+63' + cleanedNumber.slice(1) 
                : '+63' + cleanedNumber;
        
            return formattedNumber;
        };
        
        let approverNumbers = [];

        if(myApprover.primaryApprover){
            if(myApprover.primaryApprover.primaryApprover1Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover1Id,
                        fullName: myApprover.primaryApprover.primaryApprover1FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover2Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover2Id,
                        fullName: myApprover.primaryApprover.primaryApprover2FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover3Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover3Id,
                        fullName: myApprover.primaryApprover.primaryApprover3FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover4Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.primaryApprover.primaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover4Id,
                        fullName: myApprover.primaryApprover.primaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.secondaryApprover){
            if(myApprover.secondaryApprover.secondaryApprover1Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover1Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover1FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover2Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover2Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover2FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover3Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover3Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover3FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover4Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.secondaryApprover.secondaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover4Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.tertiaryApprover){
            if(myApprover.tertiaryApprover.tertiaryApprover1Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover1Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover1FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover2Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover2Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover2FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover3Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover3Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover3FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover4Id){
                const foundndInfo = employeesInfo.find(info => info.id === myApprover.tertiaryApprover.tertiaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover4Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover4FullName
                    });
                }
            }
        }

        return approverNumbers;
    };
    const sendSmsBulk = async (smsData) => {
        try {
            const response = await axios.post('http://161.49.93.114:8081/api/Sms/send-sms-bulk', smsData); // euro asia
            // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms-bulk', smsData); // my server
            console.log(response, `SMS request sent successfully.`);
        } catch (error) {
            console.error(`Error sending SMS request`, error);
        }
    };

    const handlePostStaging = async () => {
        const apiUrl = `${domain}/api/OvertimeRequestStaging/post-staging`;
        setLoadingRequest(true);
        closePostStagingConfirmationHandleClick();

        const approverHierarchies = await fetchDataApproverHierarchy();
        const employeesInfo = await fetchDataEmployees();
    
        try {
            const response = await axios.post(apiUrl, overtimeRequestDataForOvertimeList, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();

            let requestsToBeSent = [];

            for (let i = 0; i < overtimeRequestDataForOvertimeList.length; i++) {
                const formattedNumber = overtimeRequestDataForOvertimeList[i].referenceNumber.toString().padStart(6, '0');
                const approver = approverHierarchies.find(data => data.employeePersonalInformationId === overtimeRequestDataForOvertimeList[i].employeePersonalInformationId);
                const contacts = await getApproverContact(approver, employeesInfo);

                if(contacts.length <= 0){
                    continue;
                }

                const composeMessage = 
`Hello,

${overtimeRequestDataForOvertimeList[i].employeePersonalInformationFullName} filed an Overtime Request. 

Please check reference number OT-${formattedNumber} in the portal.`
;

                for (const contact of contacts) {
                    const smsData = {
                        requestTypeId: 3,
                        date: new Date(),
                        senderId: overtimeRequestDataForOvertimeList[i].employeePersonalInformationId,
                        senderFullName: overtimeRequestDataForOvertimeList[i].employeePersonalInformationFullName,
                        message: composeMessage,
                        recipientId: contact.id,
                        recipientFullName: contact.fullName,
                        recipientMobileNumber: contact.phoneNumber // phoneNumber
                    }

                    requestsToBeSent.push(smsData);
                }
            }

            if(requestsToBeSent.length > 0){
                await sendSmsBulk(requestsToBeSent);
            }

            setLoadingRequest(false);
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Post successful:', response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        }

        setLoadingRequest(false);
    }
    const openPostStagingConfirmationHandleClick  = () =>{
        setShowPostStagingConfirmationForm(true);
    }
    const closePostStagingConfirmationHandleClick = () =>{
        setShowPostStagingConfirmationForm(false);
    }

    const handleDeleteAll = async () => {
        const apiUrl = `${domain}/api/OvertimeRequestStaging/bulk-delete`;
        setLoadingRequest(true);
        closeDeleteAll();
    
        try {
            const response = await axios.delete(apiUrl, {
                data: overtimeRequestDataForOvertimeList,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setLoadingRequest(false);
            setRequestMessage('Delete successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Delete successful:', response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        }

        setLoadingRequest(false);
    }
    const openDeleteAll = () =>{
        setShowDeleteAll(true);
    }
    const closeDeleteAll = () =>{
        setShowDeleteAll(false);
    }

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [overtimeType, setOvertimeType] = useState("");
    const [remarks, setRemarks] = useState("");
    const [date, setDate] = useState("");
    const [hours, setHours] = useState("");

    const [selectedData, setSelectedData] = useState(null);
    const [showEditForm, setShowEditForm] = useState(false);
    const openEditForm = (data) => {
        setShowEditForm(true);
        setSelectedData(data);
    }
    const closeEditForm = () => {
        setShowEditForm(false);
        setSelectedData(null);
    }
    useEffect(() => {
        if(showEditForm){
            setEmployeePersonalInformationId(selectedData.employeePersonalInformationId);
            setEmployeePersonalInformationFullName(selectedData.employeePersonalInformationFullName);
            setOvertimeType(selectedData.overtimeClassification);
            setDate(selectedData.date);
            setHours(selectedData.overtimeInHours);
            setRemarks(selectedData.remarks);
        }
    }, [showEditForm, selectedData])
    const updateRequest = async (event) => {
        event.preventDefault();
        if(!remarks || !hours){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please input hours and remarks");

            return;
        }

        setLoadingRequest(true);

        const apiUrl =  domain + "/api/OvertimeRequestFromBiometrics";

        let data = {
            employeePersonalInformationId: employeePersonalInformationId, //temporary
            date: selectedData.date,
            overtimeInHours: hours,
            overtimeClassification: selectedData.overtimeClassification,
            isApproved: selectedData.isApproved,
            reason: selectedData.reason,
            isUpdated: true,
            originalHours: selectedData.originalHours,
            orignalDate: selectedData.orignalDate,
            updatedById: user.id,
            updatedDate: new Date(),
            remarks: remarks
        };

        try {
            const reponse = await axios.put(apiUrl + `/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Data updated successfully', reponse.data);
            
            closeEditForm();

            // Reload table data and reset form fields
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            setRequestMessage("Request Successful");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const openDeleteForm = (data) => {
        setShowDeleteForm(true);
        setSelectedData(data);
    }
    const closeDeleteForm = () => {
        setShowDeleteForm(false);
        setSelectedData(null);
    }
    const handleDelete = async () => {
        const apiUrl = `${domain}/api/OvertimeRequestFromBiometrics/delete/${selectedData.id}`;
        setLoadingRequest(true);
        closeDeleteForm();
    
        try {
            const response = await axios.delete(apiUrl, {
                data: overtimeRequestDataForOvertimeList,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setLoadingRequest(false);
            setRequestMessage('Delete successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Delete successful:', response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        }

        setLoadingRequest(false);
    }

    const handleApprove = async () => {
        setLoadingRequest(true);
        closeApproveForm();

        const apiUrl = `${domain}/api/OvertimeRequestFromBiometrics`;

        try {
            await axios.post(apiUrl + `/post-approve-bulk`, selectedDTR, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Updated successfully');

            await SetAuditTrail({
                setupArea: "Mass Approval", 
                actionTaken: "mass approval", 
                field: "Approve", 
                newValue: "Approved", 
                oldValue: "Pending", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            // Reload table data and reset state
            await fetchData();

            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem updating record:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
            setShowRequestMessage(true);
            setIsSuccess(false);
        } finally {
            setLoadingRequest(false);
        }
    }

    console.log(typeof filterDataIndexForOvertimeList, filterDataIndexForOvertimeList)

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                    <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                    <span style={{borderBottom:"1px solid black"}}>{"Mass Approval"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Mass Approval</h3>
                                <div style={{width:"30%",textAlign:"right", display: "none"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            openPostFormHandleClick={openPostStagingConfirmationHandleClick}
                                            openDeleteAll={openDeleteAll}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="transaction-body">
                            <div className='loan-tab overtimelist'>
                                <div>
                                    <div className='filters-payroll'>
                                        <span>Filter</span>
                                        <div className="payroll-item-holder info-item-holder row" style={{justifyContent:"space-evenly", padding: "0 10px 20px 10px"}}>
                                            <div className="filter-item-payroll popUp-item info-item column">
                                                <div className="info-item-label">Payroll Period</div>
                                                <div className="info-item-input">
                                                    <PayrollPeriodIdSelect payrollPeriodId={filterPayrollPeriodId} setPayrollPeriodId={setFilterPayrollPeriodId}/>
                                                </div>
                                                <span style={{
                                                    visibility: "hidden",
                                                    color:"#ff6565", 
                                                    fontSize:"12px"}}>Please fill up Pay Type first
                                                </span>
                                            </div>
                                            <div className="filter-item-payroll popUp-item info-item column">
                                                <div className="info-item-label">Location</div>
                                                <div className="info-item-input">
                                                    <LocationIdSelect locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                                </div>
                                                <span style={{
                                                    visibility: "hidden",
                                                    color:"#ff6565", 
                                                    fontSize:"12px"}}>Please fill up Pay Type first
                                                </span>
                                            </div>
                                            <div className="filter-item-payroll popUp-item info-item column">
                                                <div className="info-item-label">Status</div>
                                                <div className="info-item-input">
                                                    <StatusSelect data={filterDataIndexForOvertimeList} setData={setFilterDataIndexForOvertimeList}/>
                                                </div>
                                                <span style={{
                                                    visibility: "hidden",
                                                    color:"#ff6565", 
                                                    fontSize:"12px"}}>Please fill up Pay Type first
                                                </span>
                                            </div>
                                        </div>
                                        <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", handleGenerate, "GENERATE", RestartAltIcon)}</div>
                                    </div>
                                    <div style={{padding:"20px 0"}}>
                                        {/* {FilterForOvertimeList(setFilterDataIndexForOvertimeList)} */}
                                        <div className="transaction-body-top row">
                                            {CreateSearchBarWithPlaceHolder("", 
                                                                            "transaction-search row", 
                                                                            "transaction-search-icon", 
                                                                            "transaction-search-input", 
                                                                            (e)=>handleFilterForOvertimeList(e.target.value), 
                                                                            `Search by name or employee id`,
                                                                            SearchIcon)}
                                            <div className="transaction-addBtn row" style={{display:"none"}}>
                                                {CreateButton("", "approve row", "handleConfirmationApproveFromOvertimeList", "APPROVE", DoneIcon)}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className='filters-payroll row' style={{border: "none", alignItems: "center"}}>
                                        <div className="rightSide-btn" style={{marginRight:"5px", padding: "5px 0"}}>{CreateButton("", "download row", openDownloadLogs, "DOWNLOAD", SimCardDownloadIcon)}</div>
                                        <div className="rightSide-btn" style={{marginRight:"5px", padding: "5px 0"}}>{CreateButton("", "generate row", openApproveForm, "APPROVE", DoneIcon)}</div>
                                        <div className="rightSide-btn" style={{marginRight:"5px", padding: "5px 0"}}>{CreateButton("", "generate row", ()=>setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}</div>
                                        <div className="rightSide-btn" style={{marginRight:"5px", padding: "5px 0"}}>{CreateButton("", "generate row", ()=>setIsUnselectAll(true), "UNSELECT ALL", ChecklistIcon)}</div>
                                    </div>
                                    <div className="transaction-table container">
                                        <CreateTableForOvertimeList
                                            dataList={overtimeRequestDataForOvertimeList}
                                            dataHeader={headerForOvertimeList}
                                            dataAccessor={accessorForOvertimeList}
                                            selectedToAdd={selectedToAdd} 
                                            setSelectedToAdd={setSelectedToAdd}
                                            selected={selectedDTR}
                                            setSelected={setSelectedDTR}
                                            isSelectAll={isSelectAll}
                                            setIsSelectAll={setIsSelectAll}
                                            isUnselectAll={isUnselectAll}
                                            setIsUnselectAll={setIsUnselectAll}
                                            activeRowIds={activeRowIds}
                                            setActiveRowIds={setActiveRowIds}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            openEditForm={openEditForm}
                                            openDeleteForm={openDeleteForm}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditOTForm  isOpen={showEditForm} 
                    onClose={closeEditForm}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    employeePersonalInformationId={employeePersonalInformationId}
                    overtimeType={overtimeType}
                    date={date}
                    hours={hours}setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setOvertimeType={setOvertimeType}
                    setHours={setHours}
                    setDate={setDate}
                    remarks={remarks} setRemarks={setRemarks}
                    handleUpdate={updateRequest}
            >
            </EditOTForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteForm}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <ConfirmationPostForm  isOpen={showPostStagingConfirmationForm} 
                        onClose={closePostStagingConfirmationHandleClick}
                        handleConfirm={handlePostStaging}
            >
            </ConfirmationPostForm>
            <DeleteAllForm  isOpen={showDeleteAll} 
                    onClose={closeDeleteAll}
                    handleDelete={handleDeleteAll}
            >
            </DeleteAllForm>
            <DownloadLogs  isOpen={showDownloadLogs} 
                    onClose={closeDownloadLogs}
                    fetchData={fetchData}
            >
            </DownloadLogs>
            <ApproveForm isOpen={showApproveForm} 
                    onClose={closeApproveForm}
                    handleApprove={handleApprove}>

            </ApproveForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function SettingInit({
    generateDownloadTemplate,
    openUploadFormHandleClick,
    openPostFormHandleClick,
    openDeleteAll
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Overtime Request/s
            </div>
            <div className="payroll-setting-item row"onClick={()=>openDeleteAll()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><DeleteSweepIcon/></div>
                Delete All Requests
            </div>
            <div className="payroll-setting-item row"onClick={()=>openPostFormHandleClick()}>
            <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><PostAddIcon/></div>
                Post Overtime Request/s
            </div>
        </div>
    )
}
function CreateTableForOvertimeList({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    setSelectedEmployee ,
    selectedToAdd,
    setSelectedToAdd,
    
    selected,
    setSelected,
    isSelectAll,
    setIsSelectAll,
    isUnselectAll,
    setIsUnselectAll,
    activeRowIds,
    setActiveRowIds,

    currentPage, setCurrentPage,
    openEditForm,
    openDeleteForm
}) {
    // const [currentPage, setCurrentPage] = useState(1);
    // const [activeRowId, setActiveRowId] = useState(null);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // const handleRowClick = (rowData) => {
    //     setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
    //     setActiveRowId(rowData.id);
    // };

    // Select all logic
    useEffect(() => {
        if (isSelectAll) {
            const newActiveRowIds = rows.map((item) => item.original.id);
            const newActiveRowOriginal = rows.map((item) => item.original);
    
            // Prevent redundant updates
            if (JSON.stringify(newActiveRowIds) !== JSON.stringify(activeRowIds)) {
                setActiveRowIds(newActiveRowIds);
            }
            if (JSON.stringify(newActiveRowOriginal) !== JSON.stringify(selected)) {
                setSelected(newActiveRowOriginal);
            }
            setIsSelectAll(false)
        }
    }, [isSelectAll, setIsSelectAll, activeRowIds, rows, selected, setActiveRowIds, setSelected]); // Only depends on isSelectAll

    // Row click handler
    const handleRowClick = (rowData) => {
        setSelected((prevSelected) => {
            const isAlreadySelected = prevSelected.some(
                (item) => item.id === rowData.id
            );
            return isAlreadySelected
                ? prevSelected.filter((item) => item.id !== rowData.id)
                : [...prevSelected, rowData];
        });

        setActiveRowIds((prevIds) =>
            prevIds.includes(rowData.id)
                ? prevIds.filter((id) => id !== rowData.id)
                : [...prevIds, rowData.id]
        );
    };

    useEffect(() => {
        if (isUnselectAll) {
            if (activeRowIds.length > 0) {
                setActiveRowIds([]); // Only clear if not already empty
            }
            if (selected.length > 0) {
                setSelected([]); // Only clear if not already empty
            }

            setIsUnselectAll(false);
        }
    }, [isUnselectAll, setIsUnselectAll, activeRowIds, selected, setActiveRowIds, setSelected]);

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr
                                    key={row.original.id}
                                    {...row.getRowProps()}
                                    onClick={() =>
                                        handleRowClick(row.original)
                                    }
                                    className={
                                        activeRowIds.includes(row.original.id)
                                            ? "active"
                                            : ""
                                    }
                                    id={
                                        row.original.reasonForTampering
                                            ? "tampered"
                                            : ""
                                    }
                                    style={{backgroundColor: row.original.hasBeenPostedAsApproved && !activeRowIds.includes(row.original.id) ? "#ff7be3" : ""}}
                                >
                                {row.cells.map((cell) => (
                                    <SetInfoForOvertimeList header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            selectedToAdd={selectedToAdd} 
                                            setSelectedToAdd={setSelectedToAdd}
                                            openEditForm={openEditForm}
     openDeleteForm={openDeleteForm}
                                    />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForOvertimeList({
    header, 
    _cell,
    selectedToAdd,
    setSelectedToAdd,
    openEditForm,
    openDeleteForm
}) {
    const data = _cell.render("Cell").props.row.original;
    const [isChecked, setIsChecked] = useState(false);
    const value = _cell.render("Cell").props.value;

    useEffect(() => {
        setIsChecked(data.hasBeenPostedAsApproved);
    }, [data]);

    const handleItem = (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);

        if (checked) {
            setSelectedToAdd(prevItems => [...prevItems, data]);
        } else {
            setSelectedToAdd(prevItems => prevItems.filter(i => i !== data));
        }
    };

    if(header === "Is Approved?"){
        return (
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={isChecked}
                    onChange={handleItem}
                    // disabled={data.status !== "Sent" && data.status !== "Pending" }
                    disabled
                />
            </td>
        )
    }

    if(header === "Original Hours" || header === "Hours"){
        return (
            <td>
                {value ? value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
            </td>
        );
    }

    if(header === "Status"){
        const value = _cell.render("Cell").props.value;

        if(value === "Sent"){
            return(
                <td>
                    {"Pending"}
                </td>
            )
        } 
        
        return(
            <td>
                {value}
            </td>
        )
    }

    if(header === "Date"){
        const date = new Date(data.date);

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if(header === "Details"){
        const value = _cell.render("Cell").props.value;
        
        return(
            <td style={{ whiteSpace: "pre-line" }}>
                {value}
            </td>
        )
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>openEditForm(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>openDeleteForm(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
/* function FilterForOvertimeList(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "Pending":
                setFilterDataIndex(1);
                break;
            case "Approved":
                setFilterDataIndex(2);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
            </select>
        </div>
    );
}; */
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Data"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function DownloadLogs({isOpen, 
    onClose,
    fetchData,
}){
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [locationId, setLocationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleProcess(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setLocationId("");
        setErrorState(false);
    };

    const apiUrlRef = useRef( domain + `/api/OvertimeRequestFromBiometrics`);
    
    const handleProcess = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/download/payrollperiod/${payrollPeriodId}/location/${locationId ? locationId : 0}`;
    
        try {
            setLoadingRequest(true);
    
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await fetchData();
    
            setShowRequestMessage(true);
            setIsSuccess(true);
    
            handleClose();
        } catch (error) {
            // Stop any ongoing simulation
            setLoadingRequest(false); // Set the loading state to false
    
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
    
            // Safeguard in case the error structure is different
            const errorMessage = error?.response?.data?.message || 'An error occurred during processing.';
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Download Data</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId}/>
                            </div>
                            <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{"Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{"Please fill up this field"}
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                PROCESS
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function ConfirmationPostForm({isOpen, 
    onClose, 
    handleConfirm}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Post Staging Confirmation</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to post the overtime requests?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleConfirm}
                            style={{marginRight:"5px"}}>
                                POST
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteAllForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete All!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete all requests?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditOTForm({isOpen, 
    onClose, 
    employeePersonalInformationFullName, 
    employeePersonalInformationId,
    overtimeType, 
    date, 
    hours, 
    setEmployeePersonalInformationFullName,
    setEmployeePersonalInformationId,
    setOvertimeType,
    setHours,
    setDate,
    remarks,
    setRemarks,
    handleUpdate,
})
{
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullName"
                                placeholder="Employee"
                                value={employeePersonalInformationFullName}
                                onChange={(e) => setEmployeePersonalInformationFullName(e.target.value)}
                                style={{cursor:"not-allowed"}}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Overtime Type</div>
                            <div className="info-item-input">
                                <OvertimeTypeSelect overtimeType={overtimeType} setOvertimeType={setOvertimeType} isView={true}/>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date</div>
                                <div className="info-item-input">
                                    {DateTimeInput(date, setDate, true)}
                                </div>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Hours</div>
                                <div className="info-item-input">
                                    <input
                                    type='number'
                                    id="hours"
                                    placeholder="Hours"
                                    value={hours}
                                    onChange={(e) => setHours(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Remarks</div>
                                <div className="info-item-input">
                                    <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            style={{marginRight: "5px"}}
                            onClick={handleUpdate}>
                                Update
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this requests?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ApproveForm({isOpen, 
    onClose, 
    handleApprove}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Approval!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to approve selected data?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleApprove}
                            style={{marginRight:"5px"}}>
                                APPROVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function OvertimeTypeSelect({overtimeType, setOvertimeType, isView}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setOvertimeType(event.target.value);
    };

    useEffect(() => {
        if(overtimeType !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [overtimeType]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={isView} value={overtimeType} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose overtime type</option>
            <option value="Regular">Regular</option>
            <option value="Restday">Restday</option>
            <option value="SpecialHoliday">Special Holiday</option>
            <option value="RegularHoliday">Regular Holiday</option>
            <option value="RestdaySpecialHoliday">Restday Special Holiday</option>
            <option value="RestdayRegularHoliday">Restday Regular Holiday</option>
            </select>
        </div>
    );
};
function DateTimeInput(date, setDate, isView) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            readOnly={isView}
            type="datetime-local"
            id={"datetime-"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function LocationIdSelect({locationId, setLocationId}){
    const handleSelectChange = (event) => {
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ height: "30px", color: "rgb(104, 104, 104)" }}>
            <option value="" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
function StatusSelect({ data, setData }) {
    const handleSelectChange = (event) => {
        const value = Number(event.target.value);  // 👈 Convert to number
        setData(value);

        console.log("value type:", typeof value, value); // number
    };

    console.log("data", typeof data, data)

    return (
        <div>
        <select
            value={data || 0}
            onChange={handleSelectChange}
            style={{ height: "30px", color: "rgb(104, 104, 104)" }}
        >
            <option value={0}>All</option>
            <option value={1}>Pending</option>
            <option value={2}>Approved</option>
        </select>
        </div>
    );
}

function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        // const currentYear = new Date().getFullYear();
        // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {data.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default MassApproval
